export const ACTION_TYPES = {
	SET_CART_DATA: "SET_CART_DATA",
	SET_ERROR: "SET_ERROR",
	SET_LOADING: "SET_LOADING",
	ITEM_PENDING_DELETE: "ITEM_PENDING_DELETE",
	ITEM_PENDING_QUANTITY: "ITEM_PENDING_QUANTITY",
	UPDATE_CART_ITEM: "UPDATE_CART_ITEM",
	REMOVE_CART_ITEM: "REMOVE_CART_ITEM",
} as const;
